import styled from 'styled-components';

import { colorTokens } from '../../../shared/components/variables';

export const OutlinedCircle = styled.div<{ $isCompleted?: boolean }>`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 6px;
  color: ${(props) => (props.$isCompleted ? colorTokens.primary.main : colorTokens.text.disabled)};
  border: 1px solid ${(props) => (props.$isCompleted ? colorTokens.primary.main : colorTokens.text.disabled)};
  border-radius: 50%;
  border-width: 3px;

  svg {
    color: ${colorTokens.primary.main};
    min-width: 14px;
    min-height: 14px;
  }
`;
